import { defineMessage } from "react-intl";
import VerifiableEmailHelper from "../../lib/verifiableEmailHelper";


// TODO: This will be refactored to separate out validation logic from UI technology. Validators shouldn't need to know anything
// about the UI framework being used so if we ever swap out that tech, business logic and it's unit tests can remain consistent 
// while the UI technology is updated.
export const usernameValidator = {
    validateFormat: (username) => {
      const trimmedUsername = username?.trim();
      const errors = [];
      // Skip validation if username is empty.
      if (!trimmedUsername) {
        return errors;
      }
      const usernameValid = trimmedUsername.match(/[\p{L}\p{M}\p{S}\p{N}\p{P}]+/u)?.[0].length === trimmedUsername.length;
      if (!usernameValid) {
        errors.push({
          message: defineMessage({
            id: "invalidUsername",
            defaultMessage: "This username appears invalid, please try again",
            description: "Error message for username field"
          }),
          context: {},
          severity: "soft"
        });
        if (trimmedUsername.match(/\s/)) {
          errors.push({
            message: defineMessage({
              id: "usernameContainsSpaces",
              defaultMessage: "The username contains spaces",
              description: "Error message for username field"
            }),
            context: {},
            severity: "fatal"
          });
        }
      }
      return errors;
    },
    validateRules: () => []
  };

export const emailUsernameValidator = {
  validateFormat: (username) => {
    // Skip validation if username is empty.
    if (!username) {
      return [];
    }
    const trimmedUsername = username.trim();
    if (trimmedUsername.match(/\s/)) {
      return [{
        message: defineMessage({
          id: "login.emailRequiredForLoginError",
          defaultMessage: "Please enter a valid email address",
          description: "Error message when a non-email value is entered and email is required for login"
        }),
        context: {},
        severity: "fatal"
      }];
    }
    const emailValid = new VerifiableEmailHelper().isFormatValid(trimmedUsername);
    if (!emailValid) {
      return [{
        message: defineMessage({
          id: "login.emailRequiredForLoginError",
          defaultMessage: "Please enter a valid email address",
          description: "Error message when a non-email value is entered and email is required for login"
        }),
        context: {},
        severity: "soft"
      }];
    }
    return [];
  },
  validateRules: () => []
};